<template>
  <div class="errorMessage" :style="{left: errLeft}">
    {{title}}
  </div>
</template>
<script>
export default {
  name: 'errMessage',
  props: {
    title: {
      type: String,
      default: '请选择选项'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible (val) {
      this.errLeft = val ? 0 : '100%'
    }
  },
  data () {
    return {
      errLeft: '100%'
    }
  }
}
</script>
<style lang="scss">
.errorMessage{
  position: relative;
  left: 100%;
  padding-left: 24px;
  color: red;
  line-height: 31px;
  background-color: #ffe5e0;
  border-radius: 8px;
  font-size: 15px;
  margin-bottom: 15px;
  transition: all 1s ease 0s;
}
</style>
